import axios, { AxiosResponse } from 'axios';
import {
  //addNotificationReq,
  //addNotificationRes,
  deleeNotificationRes,
  deleteNotificationReq,
  hrAnnouncementReq,
  hrAnnouncementRes,
  //hrNotificationReq,
  //hrNotificationRes,
  notificationReq,
  notificationRes,
  UpdateNotificationStatusReq,
  UpdateNotificationStatusRes,
  UploadDocRes,
} from './types';
import {
  POST_DELETE_NOTIFICATION_URL,
  //POST_HR_NOTIFICATION_LIST_URL,
  // POST_INSERT_NOTIFICATION_URL,
  POST_NOTIFICATION_LIST_URL,
  POST_UPDATE_HR_NOTIFICATION_STATUS_URL,
  POST_UPLOAD_NOTIFICATION_URL,
  POST_HR_ANNOUNCEMENT_LIST_URL,
  POST_INSERT_ANNOUNCEMENT_URL,
  GET_ANNC_TYPE_URL,
} from './constants';

export const getNotificaionList = async (
  payload: notificationReq
): Promise<AxiosResponse<notificationRes>> => {
  try {
    const response = await axios.post<notificationRes>(
      POST_NOTIFICATION_LIST_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
export const addAnnouncement = async (
  payload: hrAnnouncementReq
): Promise<AxiosResponse<hrAnnouncementRes>> => {
  try {
    const response = await axios.post<hrAnnouncementRes>(
      POST_INSERT_ANNOUNCEMENT_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
export const deleteNotificaion = async (
  payload: deleteNotificationReq
): Promise<AxiosResponse<deleeNotificationRes>> => {
  try {
    const response = await axios.post<deleeNotificationRes>(
      POST_DELETE_NOTIFICATION_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
export const updateNotiicationStatus = async (
  payload: UpdateNotificationStatusReq
): Promise<AxiosResponse<UpdateNotificationStatusRes>> => {
  try {
    const response = await axios.post<UpdateNotificationStatusRes>(
      POST_UPDATE_HR_NOTIFICATION_STATUS_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};

export const uploadDocument = async (
  formData: FormData
): Promise<AxiosResponse<UploadDocRes>> => {
  try {
    const response = await axios.post<UploadDocRes>(
      POST_UPLOAD_NOTIFICATION_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error: any) {
    throw new Error(
      error.response?.data.message ?? 'Failed to submit Attachment'
    );
  }
};
export const getHrAnnouncementList = async (
  payload: hrAnnouncementReq
): Promise<AxiosResponse<hrAnnouncementRes>> => {
  try {
    const response = await axios.post<hrAnnouncementRes>(
      POST_HR_ANNOUNCEMENT_LIST_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
export const getAnouncements = async (): Promise<any> => {
  const response = await axios.get(GET_ANNC_TYPE_URL);
  return response.data.result;
};
